var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	51354: {
		fallback: () => (Promise.all([__webpack_require__.e(88830), __webpack_require__.e(2814), __webpack_require__.e(11817), __webpack_require__.e(36124), __webpack_require__.e(33927)]).then(() => (() => (__webpack_require__(33927))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.1.6",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core",
	},
	88830: {
		fallback: () => (Promise.all([__webpack_require__.e(17141), __webpack_require__.e(31340)]).then(() => (() => (__webpack_require__(31340))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~7.8.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxjs",
	},
	2814: {
		fallback: () => (Promise.all([__webpack_require__.e(17141), __webpack_require__.e(23620)]).then(() => (() => (__webpack_require__(23620))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~7.8.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxjs/operators",
	},
	83320: {
		fallback: () => (Promise.all([__webpack_require__.e(88830), __webpack_require__.e(82199)]).then(() => (() => (__webpack_require__(82199))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.1.6",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common",
	},
	21116: {
		fallback: () => (Promise.all([__webpack_require__.e(88830), __webpack_require__.e(2814), __webpack_require__.e(16613)]).then(() => (() => (__webpack_require__(16613))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.1.6",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common/http",
	},
	53180: {
		fallback: () => (Promise.all([__webpack_require__.e(88830), __webpack_require__.e(2814), __webpack_require__.e(83320), __webpack_require__.e(9097), __webpack_require__.e(46264), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(95072))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.1.6",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/router",
	},
	9097: {
		fallback: () => (Promise.all([__webpack_require__.e(83320), __webpack_require__.e(21116), __webpack_require__.e(94967), __webpack_require__.e(80436)]).then(() => (() => (__webpack_require__(80436))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.1.6",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser",
	},
	81380: {
		fallback: () => (Promise.all([__webpack_require__.e(51354), __webpack_require__.e(88830), __webpack_require__.e(2814), __webpack_require__.e(16450), __webpack_require__.e(81383)]).then(() => (() => (__webpack_require__(81383))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.0.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/store",
	},
	16450: {
		fallback: () => (Promise.all([__webpack_require__.e(11817), __webpack_require__.e(49074)]).then(() => (() => (__webpack_require__(49074))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.1.6",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/rxjs-interop",
	},
	63880: {
		fallback: () => (__webpack_require__.e(72076).then(() => (() => (__webpack_require__(13334))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@twa/global-environments",
	},
	59868: {
		fallback: () => (Promise.all([__webpack_require__.e(83320), __webpack_require__.e(21116), __webpack_require__.e(53180), __webpack_require__.e(9097), __webpack_require__.e(81380), __webpack_require__.e(16450), __webpack_require__.e(63880), __webpack_require__.e(60130), __webpack_require__.e(47810), __webpack_require__.e(75029), __webpack_require__.e(76041), __webpack_require__.e(43900), __webpack_require__.e(11817), __webpack_require__.e(46264), __webpack_require__.e(36712), __webpack_require__.e(36124), __webpack_require__.e(45808), __webpack_require__.e(5254)]).then(() => (() => (__webpack_require__(5254))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@twa/utils",
	},
	47810: {
		fallback: () => (Promise.all([__webpack_require__.e(94967), __webpack_require__.e(30161)]).then(() => (() => (__webpack_require__(30161))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.1.6",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser/animations",
	},
	43610: {
		fallback: () => (__webpack_require__.e(34456).then(() => (() => (__webpack_require__(34456))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.1.6",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/forms",
	},
	2140: {
		fallback: () => (Promise.all([__webpack_require__.e(88830), __webpack_require__.e(2814), __webpack_require__.e(83320), __webpack_require__.e(21116), __webpack_require__.e(86054), __webpack_require__.e(83845), __webpack_require__.e(35741)]).then(() => (() => (__webpack_require__(35741))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@twa/flags",
	},
	68802: {
		fallback: () => (Promise.all([__webpack_require__.e(64690), __webpack_require__.e(21116), __webpack_require__.e(9097), __webpack_require__.e(9227)]).then(() => (() => (__webpack_require__(64690))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.1.6",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/icon",
	},
	20402: {
		fallback: () => (Promise.all([__webpack_require__.e(83320), __webpack_require__.e(2140), __webpack_require__.e(81897)]).then(() => (() => (__webpack_require__(81897))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@twa/access-control",
	},
	26764: {
		fallback: () => (Promise.all([__webpack_require__.e(20946), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(63450))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@twa/state/route",
	},
	34310: {
		fallback: () => (() => (__webpack_require__(79975))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.1.6",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/scrolling",
	},
	80264: {
		fallback: () => (Promise.all([__webpack_require__.e(93482), __webpack_require__.e(34310), __webpack_require__.e(12587)]).then(() => (() => (__webpack_require__(12587))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.1.6",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/dialog",
	},
	99737: {
		fallback: () => (__webpack_require__.e(66231).then(() => (() => (__webpack_require__(66231))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^2.0.6",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ngx-device-detector",
	},
	21672: {
		fallback: () => (Promise.all([__webpack_require__.e(16450), __webpack_require__.e(85114)]).then(() => (() => (__webpack_require__(85114))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.0.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "angular-auth-oidc-client",
	},
	17548: {
		fallback: () => (Promise.all([__webpack_require__.e(83320), __webpack_require__.e(9097), __webpack_require__.e(63880), __webpack_require__.e(60130), __webpack_require__.e(79975), __webpack_require__.e(47810), __webpack_require__.e(87515), __webpack_require__.e(75029), __webpack_require__.e(23744), __webpack_require__.e(5642), __webpack_require__.e(93482), __webpack_require__.e(24499), __webpack_require__.e(32217), __webpack_require__.e(55970), __webpack_require__.e(35123)]).then(() => (() => (__webpack_require__(35123))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@twa/webapp/shared/services/auth",
	},
	20946: {
		fallback: () => (Promise.all([__webpack_require__.e(51354), __webpack_require__.e(2814), __webpack_require__.e(53180), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(32175))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.0.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/router-store",
	},
	76382: {
		fallback: () => (Promise.all([__webpack_require__.e(31034), __webpack_require__.e(79817)]).then(() => (() => (__webpack_require__(79817))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@twa/header",
	},
	43604: {
		fallback: () => (Promise.all([__webpack_require__.e(83320), __webpack_require__.e(16450), __webpack_require__.e(63880), __webpack_require__.e(76041), __webpack_require__.e(24499), __webpack_require__.e(92434), __webpack_require__.e(40433)]).then(() => (() => (__webpack_require__(40433))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@twa/webapp/shared/services/common",
	},
	10398: {
		fallback: () => (__webpack_require__.e(8880).then(() => (() => (__webpack_require__(8880))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@twa/webapp/shared/guards",
	},
	36988: {
		fallback: () => (Promise.all([__webpack_require__.e(48765), __webpack_require__.e(90353), __webpack_require__.e(31034), __webpack_require__.e(94806), __webpack_require__.e(38223), __webpack_require__.e(35723), __webpack_require__.e(16373), __webpack_require__.e(47101), __webpack_require__.e(29966)]).then(() => (() => (__webpack_require__(91798))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@twa/layouts",
	},
	48673: {
		fallback: () => (__webpack_require__.e(70347).then(() => (() => (__webpack_require__(70347))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.0.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/effects",
	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"2140": [
		2140
	],
	"2814": [
		2814
	],
	"9097": [
		9097
	],
	"16450": [
		16450
	],
	"17548": [
		17548
	],
	"20946": [
		20946
	],
	"21116": [
		21116
	],
	"23744": [
		68802
	],
	"32217": [
		80264
	],
	"34310": [
		34310
	],
	"45808": [
		99737
	],
	"47810": [
		47810
	],
	"51354": [
		51354
	],
	"53180": [
		53180
	],
	"55970": [
		21672
	],
	"62891": [
		20402,
		26764
	],
	"63880": [
		63880
	],
	"75029": [
		43610
	],
	"79489": [
		76382
	],
	"81380": [
		81380
	],
	"83320": [
		83320
	],
	"83930": [
		10398,
		36988,
		48673
	],
	"86054": [
		59868
	],
	"88830": [
		88830
	],
	"90656": [
		43604
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}